// ----------------------------------------------------------------------
// <copyright file="Izenda.Import.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import fetcher from 'share/fetch/Izenda.Fetch';
import ImportErrorPopup from './Popup/Izenda.ImportErrorPopup';
import { FILE_EXTENSION } from 'logic/data/Izenda.ImportConstants';
import FileDropzone from 'share/components/hoc/Izenda.FileDropzone';
import FileUpload from 'share/components/controls/FileUpload/Izenda.FileUpload';
import { isEmpty, join } from 'lodash/fp';

@connect()
export default class ImportFile extends Component {
  handleDropFiles = (files: Array<any>) => {
    const { store, loader } = this.props;
    loader.startLoading();
    store
      .uploadFiles(files)
      .then(this.handleAfterUploadFiles)
      .finally(loader.endLoading.bind(loader));
  };

  handleAfterUploadFiles = () => {
    const { store, store: { model: { invalidFileMessages } } } = this.props;
    if (!isEmpty(invalidFileMessages)) {
      this.props.openPopup(ImportErrorPopup, { messages: invalidFileMessages, store });
    }

    return Promise.resolve();
  };

  renderDropzone = ({ isOver }): any => {
    const { localization } = this.props;
    const classes = classnames('izenda-ImportFile-description', { isOver });
    return <div className={classes}>{localization.getText('IMPORT_LABEL_DRAG_AND_DROP_FILES')}</div>;
  };

  render() {
    const { localization, store } = this.props;
    const options = {
      baseUrl: 'importManagement/file',
      param: {
        batchId: String.newGuid()
      },
      requestHeaders: fetcher().getAuthHeader(),
      chooseAndUpload: true,
      multiple: true,
      accept: join([FILE_EXTENSION.REPORT, FILE_EXTENSION.DASHBOARD], ','),
      wrapperDisplay: 'inline',
      uploadSuccess: (content: any) => {
        store.createImportContent(content);
        this.handleAfterUploadFiles();
      }
    };

    return (
      <div className="u_flexVertical u_alignItemCenter u_flexJustifyCenter u_fullHeight">
        <FileDropzone onDrop={this.handleDropFiles} render={this.renderDropzone} />
        <span className="u_marginAll">{localization.getText('COMMON_LABEL_OR')}</span>
        <FileUpload isHighlight={false} options={options} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Izenda.ImportFile.js